import { StepShell } from '../components/layout';
import { TextArea } from '../components/inputs';

export default function FinalReflectionStep({ data, update, notes = {} }) {
  return (
    <StepShell
      eyebrow="Step 17 of 18"
      title="Anything we haven’t asked?"
      lede="Forms are blunt instruments. If there is something about you that none of the previous questions got at, this is the place for it."
      encouragement="Plenty of people leave this blank and it makes no difference to their application. Only write something if you want to."
    >
      <TextArea
        id="reflection"
        label="Over to you"
        optional
        rows={6}
        maxLength={1500}
        placeholder="Something you are proud of, a circumstance worth knowing about, or just why you want to do this."
        value={data.reflection}
        note={notes.reflection}
        onChange={(v) => update({ reflection: v })}
      />
    </StepShell>
  );
}
